import React, { FC } from 'react';
import { Translate } from 'i18n';
import { APP_SERVER_URL } from 'students/constants';
import LinkElem from 'students/views/shared/components/LinkElem';
import UrlIcon from 'students/views/shared/components/UrlIcon/UrlIcon';
import rightArrowIcon from 'students/views/shared/assets/icons/arrow_right_icon.svg';
import { NAV_ROW_CLASS_NAME, NAV_ROW_TEXT_CLASS_NAME } from './styles';

const APP_URL = new URL(APP_SERVER_URL);
const APP_HOST_WITHOUT_MY = APP_URL.host.replace(/^my\./, '');
export const TEACHER_APP_URL = `${APP_URL.protocol}//app.${APP_HOST_WITHOUT_MY}`;

const GoToTeacherArea: FC = () => {
  return (
    <LinkElem
      to={TEACHER_APP_URL}
      className={`${NAV_ROW_CLASS_NAME} ${NAV_ROW_TEXT_CLASS_NAME} ln-gap-[20px] ln-rounded-[16px] hover:ln-text-content hover:ln-no-underline ln-duration-300`}
    >
      <span className="ln-flex-1">
        <Translate str="frontend.profile.navigation.go_to_teacher_area" />
      </span>
      <UrlIcon
        url={rightArrowIcon}
        color="currentColor"
        className="ln-text-white/50 light:ln-text-content/60"
        height="24px"
        width="24px"
      />
    </LinkElem>
  );
};

export default GoToTeacherArea;
